import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { gameData } from "../utils/gameData";

const Game = () => {
	const { id } = useParams();
	const iframeEle = useRef(null);
	const [game, setGame] = useState({});
	const [gameLoading, setGameLoading] = useState(false);

	useEffect(() => {
		setGameLoading(true);
		if (id) {
			const currentGame = gameData?.filter((g) => g?.code === id);
			setGame(currentGame[0]?.url);
		}
		setTimeout(() => setGameLoading(false), 3000);
	}, [id]);

	if (!id) {
		return <>Game Not Found</>;
	}

	return (
		<>
			{gameLoading ? (
				<div className="w-full h-full flex flex-row justify-center items-center bg-black text-5xl font-bold text-white bg-[#202124]">
					<iframe
						title="loader"
						src="https://lottie.host/embed/8f950f1d-685d-45e5-9cf1-fe8bf2fb825a/T60dXfz0e8.json"
					></iframe>
				</div>
			) : (
				<div className="w-full h-full flex flex-row justify-center items-center bg-black lg:bg-[#202124]">
					<div
						id="game"
						className=" relative w-full h-full mx-auto flex justify-center"
					>
						<embed
							id="gameFrame"
							ref={iframeEle}
							src={game}
							width="100%"
							height="100%"
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default Game;
